const EndPoints = {
    ad_list: 'streaming/video/ad-list',
    find_video_by_id: 'streaming/video/find-by-id',
    details: 'streaming/channel/list',
}
export default EndPoints